import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';
import { AdminService } from 'src/app/modules/admin/services/admin.service';
import { INegotiation, INegotiationCreateRequest, NegotiationStatusEnum } from 'src/app/modules/pr-buyer/models';
import { BuyerSupplierService } from 'src/app/modules/pr-buyer/services/buyer-supplier.service';

@Component({
  selector: 'app-negotiation-update-info',
  templateUrl: './negotiation-update-info.component.html',
  styleUrls: ['./negotiation-update-info.component.scss']
})
export class NegotiationUpdateInfoComponent implements OnInit {
  
  public title !: string;
  public onClose = new BehaviorSubject<any>({});
  public paymentTermsList !: any;

  public negotiationResultTable : Record<string | number, INegotiation[]> = {}; // Hashmap to store key value of supplierId and negotiation object array
  public negotiationRequest !: INegotiationCreateRequest;
  
  public negotiationForm !: FormGroup; // A form which would give a value of "Record<string | number, INegotiation[]>"

  // hashmap record for toggle accordion
  public accordionToggleMap : Record<string | number, boolean> = {};

  constructor(
    public bsModalRef: BsModalRef,
    private _toastr : ToastrService,
    private _adminService: AdminService,
    private _buyerSupplierService : BuyerSupplierService,
    private _fb : FormBuilder) { }
  
  ngOnInit(): void {
    console.log(this.negotiationRequest);
    if(this.negotiationRequest?.negotiation_data?.length) {
      this._adminService.getPaymentTermKey().subscribe((res:any)=>{
        if(res.status = 200){
          this.paymentTermsList = res.data.map((data: any) => { return { value: data.code + `(` + data.description + `)` } })
        }
      })
      this.prepareTabularData();
      this.prepareDynamicForm();
    } 
  }

  getFormArrayName(prop: string): any {
    const formArr =  this.negotiationForm.controls[prop] as FormGroup;
    return formArr.controls
  }

  getVendorName(supplierId : string | number) : string {
    const supplier = this.negotiationRequest.negotiation_data.find(x=>x.supplier_id == supplierId);
    if(supplier?.supplier_name) return supplier.supplier_name
    return ""
  }

  private prepareTabularData() : void {
    this.negotiationRequest.negotiation_data.forEach((x : INegotiation) => {
      if(this.negotiationResultTable && this.negotiationResultTable.hasOwnProperty(x.supplier_id) && this.negotiationResultTable[x.supplier_id]) {
        this.negotiationResultTable[x.supplier_id].push(x);
      } else {
        this.negotiationResultTable[x.supplier_id] = [x];
        this.accordionToggleMap[x.supplier_id] = true; // Setting the value to true so accordion is open by default
      }
    });
    console.log(this.negotiationResultTable);
  }

  private prepareDynamicForm() : void {
    const customForm : FormGroup = this._fb.group({});
    Object.keys(this.negotiationResultTable).forEach((supplier_id : any) => {
      const formArray : FormArray =  new FormArray([]);
      this.negotiationResultTable[supplier_id].forEach((negotiation : INegotiation) => {
        const nestedForm : FormGroup =  this._fb.group({});
        Object.keys(negotiation).forEach((key : string) => {
          const defaultValue = negotiation[key as keyof INegotiation];
          // if(key === "buyer_counter_offer" || key === "buyer_remarks") { /* If fiels is buyer_counter_offer or buyer_remarks then adding validator */
          if(key === "buyer_counter_offer"){ //removed required validator for Remarks
            nestedForm.addControl(key, new FormControl(defaultValue, []));
          } else {
            nestedForm.addControl(key, new FormControl(defaultValue, []));
          }
        })
        formArray.push(nestedForm);
      });
      customForm.addControl(supplier_id, formArray)
    });
    this.negotiationForm = customForm;
    console.log(this.negotiationForm);
  }

  public toggleAccordion(line_item_number : any) : void {
    if(this.accordionToggleMap.hasOwnProperty(line_item_number)) {
      this.accordionToggleMap[line_item_number] = !this.accordionToggleMap[line_item_number]
    } else {
      this.accordionToggleMap[line_item_number] = true;
    }
  }

  public sendNegotiation() : void {
    const negotiationRequest = this.negotiationRequest;
    const formValue : Record<string | number, INegotiation[]> = this.negotiationForm.value;
    let isUpdateRequest; 
    negotiationRequest.negotiation_data.forEach((x : INegotiation) => {
      if(formValue && formValue[x.supplier_id]) {
        const negotiationObject = formValue[x.supplier_id].find((y : INegotiation) => y.line_item_number === x.line_item_number);
        x = Object.assign(x, negotiationObject);
        if(x.negotiation_id == null) { isUpdateRequest = true } // If negotiation ID is present, then it happens to be an update request
      }
    });

    if(negotiationRequest.negotiation_data[0].supplier_id == null){
      delete negotiationRequest.negotiation_data[0].supplier_id;
    }else{
      delete negotiationRequest.negotiation_data[0].un_reg_vendor;
    }
    delete (negotiationRequest.negotiation_data[0].item_desc);
    delete (negotiationRequest.negotiation_data[0].material_code);
    delete (negotiationRequest.negotiation_data[0].original_freight_charge);
    delete (negotiationRequest.negotiation_data[0].original_packing_charge);
    delete (negotiationRequest.negotiation_data[0].supplier_remarks);
    delete (negotiationRequest.negotiation_data[0].remark);
    delete (negotiationRequest.negotiation_data[0].supplier_name);

    console.log("negotiationRequestData",negotiationRequest.negotiation_data)
    let negotiationRequestdata = negotiationRequest.negotiation_data
    negotiationRequestdata[0].negotiation_status = NegotiationStatusEnum.Negotiation_In_Progress;

    const sendNegotiation$ = isUpdateRequest ? this._buyerSupplierService.createNegotiation(negotiationRequestdata) :this._buyerSupplierService.updateNegotiation(negotiationRequestdata);
    sendNegotiation$.subscribe((res : any) => {
      this._toastr.success("Sent Successfully!");
      this.closeModal({refresh : true});
    });
  }

  public onModalClose(): void {
    this.bsModalRef.hide();
  }

  public closeModal(data ?: any) {
    this.onClose.next(data);
    this.bsModalRef.hide();
  }

}
